import {Component, OnInit} from '@angular/core';
import {Subject} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {UniversitySuccessStoryService} from '../../../shared/services/university-success-story.service';
import {UniversityService} from '../../../shared/services/university.service';
import {GlobalService} from '../../../shared/services/global.service';

@Component({
    selector: 'app-university-success-story',
    templateUrl: './university-success-story.component.html',
    styleUrls: ['./university-success-story.component.scss']
})
export class UniversitySuccessStoryComponent implements OnInit {
    public name: any;
    public quote: any;
    public rating: any;
    public photoFileId: any;
    public photoPreviewUrl: any;
    public toggleMenu = false;
    private _unsubscribeAll: Subject<any>;
    public universityId: any;
    public ratingStars = [1, 2, 3, 4, 5];
    successStories: any = [];
    submitting: any = false;
    uploadingPhoto: any = false;
    university: any;

    constructor(private router: Router,
                private activatedRoute: ActivatedRoute,
                private universitySuccessStoryService: UniversitySuccessStoryService,
                private universityService: UniversityService,
                private globalService: GlobalService) {
        this._unsubscribeAll = new Subject();
    }

    ngOnInit(): void {
        this.universityId = this.activatedRoute.snapshot.parent.params['id'];
        this.refresh();
    }

    refresh() {
        this.getUniversityDetail();
    }

    getUniversityDetail() {
        this.universityService.detail(this.universityId).subscribe(data => {
            if (data) {
                this.university = data;
                this.get();
            }
        });
    }

    get() {
        this.universitySuccessStoryService.getByAdmin(this.universityId).subscribe(data => {
            this.successStories = (data && data.length > 0) ? data : [];
        });
    }

    setRating(value: number) {
        this.rating = value;
    }

    onPhotoSelected(event) {
        this.uploadingPhoto = true;
        const params = {
            type: 'UNIVERSITY_SUCCESS_STORY_PHOTO',
            fileType: 'NORMAL',
            university_id: this.universityId,
            user_id: this.globalService.getSelf() ? this.globalService.getSelf().userId : ''
        };
        this.universitySuccessStoryService.fileUpload(params, event).subscribe(data => {
            this.uploadingPhoto = false;
            if (data && data['data']) {
                this.photoFileId = data['data'].id;
                this.photoPreviewUrl = data['data'].url;
            }
        }, error => {
            this.uploadingPhoto = false;
        });
    }

    addDetail() {
        const params = {
            name: this.name ? this.name : '',
            quote: this.quote ? this.quote : '',
            rating: this.rating ? this.rating : '',
            photo_file_id: this.photoFileId ? this.photoFileId : '',
            sort_order: this.successStories ? this.successStories.length : 0
        };
        this.submitting = true;
        this.universitySuccessStoryService.createByAdmin(this.universityId, params).subscribe(data => {
            this.submitting = false;
            this.name = undefined;
            this.quote = undefined;
            this.rating = undefined;
            this.photoFileId = undefined;
            this.photoPreviewUrl = undefined;
            this.get();
        }, error => {
            this.submitting = false;
        });
    }

    delete(id) {
        this.universitySuccessStoryService.deleteByAdmin(this.universityId, id).subscribe(data => {
            this.get();
        });
    }

    goTo(tab) {
        this.router.navigateByUrl('university/' + this.universityId + '/' + tab);
    }
}
